import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("interko_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Session unique (LSMS) : si le backend signale que la session a été fermée
// (compte utilisé sur un autre appareil), on nettoie et on renvoie vers /login.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 401 && typeof detail === "string" && detail.includes("autre appareil")) {
      localStorage.removeItem("interko_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.replace("/login?reason=session");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
